/* Blazing Banner builder: three-column desktop layout (1180px and wider only).
   Moves existing builder elements into place and mirrors builder state into an
   order summary. No builder logic is changed; below 1180px every element is
   returned to its original position. */
(function () {
  var root = document.getElementById('blazing-banner-builder-v43');
  if (!root) return;
  var wrap = root.querySelector(':scope > .wrap');
  var stage = wrap && wrap.querySelector(':scope > .stage');
  var side = root.querySelector('.bbx-side');
  var summary = root.querySelector('.bbx-summary');
  if (!wrap || !stage || !side || !summary) return;

  var mq = window.matchMedia('(min-width: 1180px)');
  var $ = function (id) { return document.getElementById(id); };

  // Elements that move, with a marker left where each one came from.
  var moves = [
    { el: $('bannerSimpleNav'), place: function (el) { stage.insertBefore(el, stage.firstChild); } },
    { el: root.querySelector('.price-block'), place: function (el) { summary.after(el); } },
    { el: root.querySelector('.ship-card'), place: function (el) { root.querySelector('.price-block').after(el); } }
  ].filter(function (m) { return m.el; });

  // ---------- Grommet controls: spacing buttons + side checkboxes ----------
  // These only drive the builder's own hidden selects, so pricing and the
  // grommet preview keep working exactly as before.
  var spacingSel = $('grommetSpacingSelect'), sidesSel = $('grommetSidesSelect');
  var grom = null;
  var SPACING_SHORT = { corners: 'Corners', '36': '3 ft', '30': '2–3 ft', '18': '1–2 ft', '9': '6–12 in' };
  var SIDE_NAMES = [['t', 'Top'], ['b', 'Bottom'], ['l', 'Left'], ['r', 'Right']];
  function sidesToValue(set) {
    var key = ['t', 'l', 'r', 'b'].filter(function (k) { return set[k]; }).join('');
    if (key.length === 4) return 'all';
    return { t: 'top', l: 'left', r: 'right', b: 'bottom' }[key] || key;
  }
  function valueToSides(v) {
    if (v === 'all') return { t: 1, l: 1, r: 1, b: 1 };
    var one = { top: 't', left: 'l', right: 'r', bottom: 'b' }[v];
    var set = {};
    (one || v || '').split('').forEach(function (k) { set[k] = 1; });
    return set;
  }
  function fire(sel, value) {
    if (sel.value === value) return;
    sel.value = value;
    sel.dispatchEvent(new Event('input', { bubbles: true }));
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function buildGrommets() {
    var toggleRow = $('grommetsToggle') && $('grommetsToggle').closest('.switch-row');
    if (!spacingSel || !sidesSel || !toggleRow) return;
    grom = document.createElement('div');
    grom.className = 'bbx-grom bbx-only-desktop';
    var html = '<div class="bbx-grom-row"><span class="bbx-grom-label">Spacing</span><div class="bbx-seg" role="group" aria-label="Grommet spacing">';
    Array.prototype.forEach.call(spacingSel.options, function (o) {
      html += '<button type="button" data-v="' + o.value + '" title="' + o.text + '">' + (SPACING_SHORT[o.value] || o.text) + '</button>';
    });
    html += '</div></div><div class="bbx-grom-row"><span class="bbx-grom-label">Sides</span><div class="bbx-checks" role="group" aria-label="Grommet sides">' +
      '<button type="button" class="bbx-all-sides" data-all-sides aria-pressed="false">All sides</button>';
    SIDE_NAMES.forEach(function (s) {
      html += '<label><input type="checkbox" data-side="' + s[0] + '"><span>' + s[1] + '</span></label>';
    });
    grom.innerHTML = html + '</div></div>';
    toggleRow.after(grom);
    grom.addEventListener('click', function (e) {
      var b = e.target.closest('.bbx-seg button');
      if (b) fire(spacingSel, b.dataset.v);
      if (e.target.closest('[data-all-sides]')) { fire(sidesSel, 'all'); syncGrommets(); }
    });
    grom.addEventListener('change', function (e) {
      var box = e.target.closest('input[data-side]');
      if (!box) return;
      var set = {};
      grom.querySelectorAll('input[data-side]').forEach(function (i) { if (i.checked) set[i.dataset.side] = 1; });
      if (!Object.keys(set).length) { box.checked = true; return; } // keep at least one side
      fire(sidesSel, sidesToValue(set));
    });
  }
  function syncGrommets() {
    if (!grom) return;
    var on = $('grommetsToggle') && $('grommetsToggle').classList.contains('on');
    grom.classList.toggle('bbx-off', !on);
    grom.querySelectorAll('.bbx-seg button').forEach(function (b) { b.classList.toggle('on', b.dataset.v === spacingSel.value); });
    var set = valueToSides(sidesSel.value);
    grom.querySelectorAll('input[data-side]').forEach(function (i) { i.checked = !!set[i.dataset.side]; });
    var all = grom.querySelector('[data-all-sides]');
    if (all) {
      var isAll = sidesSel.value === 'all';
      all.classList.toggle('on', isAll);
      all.setAttribute('aria-pressed', String(isAll));
    }
  }

  var active = false;
  function enable() {
    if (active) return;
    if (!grom) buildGrommets();
    moves.forEach(function (m) {
      m.marker = document.createComment('bbx');
      m.el.parentNode.insertBefore(m.marker, m.el);
      m.place(m.el);
    });
    root.classList.add('bbx-on');
    active = true;
    refit();
    update();
    // the inline script in the section hid the builder until this layout was in place
    requestAnimationFrame(function () { root.classList.remove('bbx-pending'); });
  }
  // Fix the canvas height to the screen (not to the columns beside it), so adding
  // banners or opening help panels never pushes the banner preview down.
  function sizeCanvas() {
    var row = $('canvasRow');
    if (!active || !row) return;
    var top = row.getBoundingClientRect().top + window.scrollY;
    var h = Math.max(300, Math.min(760, window.innerHeight - top - 90));
    root.style.setProperty('--bbx-canvas-h', Math.round(h) + 'px');
  }
  // The builder sizes its preview from the canvas box, so ask it to re-measure.
  function refit() {
    sizeCanvas();
    window.dispatchEvent(new Event('resize'));
    setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 120);
  }
  function disable() {
    if (!active) return;
    moves.slice().reverse().forEach(function (m) {
      m.marker.parentNode.insertBefore(m.el, m.marker);
      m.marker.remove();
    });
    root.classList.remove('bbx-on');
    active = false;
    if (rulerX) { rulerX.remove(); rulerY.remove(); rulerX = rulerY = null; }
    refit();
  }

  // ---------- Foot rulers along the top and left of the banner ----------
  var rulerX = null, rulerY = null;
  function inches(inputId) {
    var v = parseFloat(($(inputId) || {}).value) || 0;
    var unit = root.querySelector('.unit-btn.on');
    return unit && unit.dataset.unit === 'ft' ? v * 12 : v;
  }
  function drawRuler(el, lengthPx, lengthIn, horizontal) {
    var ft = lengthIn / 12;
    var steps = [0.5, 1, 2, 5, 10, 20, 50, 100];
    var step = steps.find(function (s) { return lengthPx / (ft / s) >= 34; }) || 100;
    var pxPerFt = lengthPx / ft;
    var html = '';
    for (var f = 0; f <= ft + 1e-6; f += step / 2) {
      var pos = (f * pxPerFt).toFixed(1);
      var major = Math.abs(f / step - Math.round(f / step)) < 1e-6;
      html += '<i class="' + (major ? 'm' : '') + '" style="' + (horizontal ? 'left' : 'top') + ':' + pos + 'px"></i>';
      if (major) html += '<b style="' + (horizontal ? 'left' : 'top') + ':' + pos + 'px">' + (Math.round(f * 10) / 10) + '</b>';
    }
    html += '<b class="u" style="' + (horizontal ? 'left:' + (lengthPx + 12) + 'px' : 'top:' + (lengthPx + 12) + 'px') + '">ft</b>';
    el.innerHTML = html;
  }
  function updateRulers() {
    if (!active) return;
    var row = $('canvasRow'), stageEl = $('bannerStage');
    if (!row || !stageEl) return;
    if (!rulerX) {
      rulerX = document.createElement('div'); rulerX.className = 'bbx-ruler bbx-ruler-x'; rulerX.setAttribute('aria-hidden', 'true');
      rulerY = document.createElement('div'); rulerY.className = 'bbx-ruler bbx-ruler-y'; rulerY.setAttribute('aria-hidden', 'true');
      row.appendChild(rulerX); row.appendChild(rulerY);
    }
    var r = row.getBoundingClientRect(), s = stageEl.getBoundingClientRect();
    var wIn = inches('widthInput'), hIn = inches('heightInput');
    if (!s.width || !wIn || !hIn) return;
    var left = s.left - r.left, top = s.top - r.top;
    rulerX.style.cssText = 'left:' + left + 'px;top:' + (top - 20) + 'px;width:' + s.width + 'px';
    rulerY.style.cssText = 'left:' + (left - 20) + 'px;top:' + top + 'px;height:' + s.height + 'px';
    drawRuler(rulerX, s.width, wIn, true);
    drawRuler(rulerY, s.height, hIn, false);
  }

  // ---------- Order summary ----------
  function optText(sel) {
    var s = $(sel);
    return s && s.selectedIndex >= 0 ? s.options[s.selectedIndex].text : '';
  }
  function set(key, text, included) {
    var b = summary.querySelector('[data-bbx="' + key + '"]');
    if (!b) return;
    if (b.textContent !== text) b.textContent = text;
    b.classList.toggle('bbx-inc', !!included);
  }
  function update() {
    syncGrommets();   // grommet controls are shown on phones too (bb-builder-mobile.css)
    if (!active) return;
    var size = ($('friendlySize') || {}).textContent || '';
    if (!size.trim()) {
      var w = ($('widthInput') || {}).value, h = ($('heightInput') || {}).value;
      var unit = root.querySelector('.unit-btn.on');
      size = w && h ? w + ' × ' + h + ' ' + (unit ? unit.textContent.trim() : '') : '';
    }
    set('size', size.trim() || '—');
    set('material', optText('materialSelect').replace(/oz/, ' oz').replace(/\bvinyl\b/, 'Vinyl') || '—');
    var weld = $('weldingToggle');
    set('hems', weld && weld.classList.contains('on') ? 'Included' : 'Not added', weld && weld.classList.contains('on'));
    var grom = $('grommetsToggle');
    set('grommets', grom && grom.classList.contains('on') ? optText('grommetSpacingSelect') + ', ' + optText('grommetSidesSelect').toLowerCase() : 'Not added');
    set('qty', (($('quantityInput') || {}).value || '1'));
    var total = $('totalPrice');
    set('total', total ? total.textContent.trim() : '');

    var thumb = summary.querySelector('.bbx-thumb');
    var img = $('previewImg');
    var src = img && img.getAttribute('src');
    var has = src && img.style.display !== 'none' && !img.hidden;
    var shown = thumb.querySelector('img');
    if (has) {
      if (!shown) {
        thumb.innerHTML = '<span class="bbx-thumb-b"><img alt="Your banner artwork"></span>';
        shown = thumb.querySelector('img');
      }
      if (shown.getAttribute('src') !== src) shown.src = src;
      // Draw the banner at its real proportions, filled or fitted like the editor.
      var ratio = Math.max(0.25, Math.min(6, (inches('widthInput') || 60) / (inches('heightInput') || 36)));
      var maxW = thumb.clientWidth * 0.9, maxH = Math.max(40, thumb.clientHeight - 12);
      var bw = Math.min(maxW, maxH * ratio);
      var active = $('bannerThumbTabs') && $('bannerThumbTabs').querySelector('.banner-thumb-tab.active .banner-thumb-preview');
      var box = shown.parentNode;
      box.style.width = Math.round(bw) + 'px';
      box.style.height = Math.round(bw / ratio) + 'px';
      shown.style.objectFit = active && active.dataset.fit === 'fill' ? 'cover' : 'contain';
    } else if (shown || !thumb.firstChild) {
      thumb.innerHTML = '<span class="bbx-thumb-empty">Upload artwork to see it here</span>';
    }
  }

  // ---------- Mini banner previews in the order breakdown + quantity rows ----------
  // Each row names its banner ("Banner 2 · 5×3 ft"); the matching top tab holds
  // that banner's artwork thumbnail, so reuse it at the banner's own proportions.
  function tabPreview(n) {
    var tabs = $('bannerThumbTabs');
    var tab = tabs && tabs.querySelectorAll('.banner-thumb-tab')[n - 1];
    return tab && tab.querySelector('.banner-thumb-preview');
  }
  function artFor(n) {
    var img = tabPreview(n) && tabPreview(n).querySelector('img');
    return img ? img.getAttribute('src') : '';
  }
  // "Fill Entire Banner" crops edge to edge; "Show Full Design" shows it all.
  function fitFor(n) {
    var p = tabPreview(n);
    return p && p.dataset.fit === 'fill' ? 'fill' : 'full';
  }
  function decorateRow(row) {
    var text = row.textContent || '';
    var n = parseInt((text.match(/Banner\s+(\d+)/i) || [])[1], 10);
    if (!n) return;
    var dims = text.match(/(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)/);
    var w = dims ? parseFloat(dims[1]) : 5, h = dims ? parseFloat(dims[2]) : 3;
    var ratio = Math.max(0.25, Math.min(6, w / h));
    var boxW = 46, boxH = 32;
    var mw = ratio >= boxW / boxH ? boxW : Math.round(boxH * ratio);
    var mh = ratio >= boxW / boxH ? Math.round(boxW / ratio) : boxH;
    var src = artFor(n), fit = fitFor(n);
    var mini = row.querySelector(':scope > .bbx-mini');
    var key = n + '|' + mw + 'x' + mh + '|' + fit + '|' + src.length + src.slice(-24);
    if (mini && mini.dataset.key === key) return;
    if (!mini) {
      mini = document.createElement('span');
      mini.className = 'bbx-mini';
      mini.setAttribute('aria-hidden', 'true');
      row.insertBefore(mini, row.firstChild);
    }
    mini.dataset.key = key;
    mini.innerHTML = '<span class="bbx-mini-b" style="width:' + mw + 'px;height:' + mh + 'px">' + (src ? '<img alt="" src="' + src + '"' + (fit === 'fill' ? ' style="object-fit:cover"' : '') + '>' : '') + '</span>';
    mini.classList.toggle('bbx-mini-empty', !src);
  }
  function decorateThumbs() {
    if (!active) return;
    root.querySelectorAll('#orderBreakdown .order-breakdown-row:not(.order-breakdown-total), #bannerQuantityRows .banner-quantity-row').forEach(decorateRow);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; update(); updateRulers(); decorateThumbs(); });
  }
  ['orderBreakdown', 'bannerQuantityRows'].forEach(function (id) {
    var el = $(id);
    if (el) new MutationObserver(schedule).observe(el, { childList: true }); // builder re-renders these lists
  });
  var lastVp = '';
  window.addEventListener('resize', function () {
    var vp = window.innerWidth + 'x' + window.innerHeight;
    if (vp !== lastVp) { lastVp = vp; sizeCanvas(); } // only real window resizes, not the builder's own resize pings
    setTimeout(schedule, 30);
  });
  // The canvas height now follows the steps column; re-fit the banner when it changes.
  var rowEl = $('canvasRow'), lastRow = '';
  if (rowEl && window.ResizeObserver) {
    new ResizeObserver(function () {
      if (!active) return;
      var b = rowEl.getBoundingClientRect(), key = Math.round(b.width) + 'x' + Math.round(b.height);
      if (key !== lastRow) { lastRow = key; window.dispatchEvent(new Event('resize')); }
    }).observe(rowEl);
  }
  var stageWatch = $('bannerStage');
  if (stageWatch) new MutationObserver(schedule).observe(stageWatch, { attributes: true, attributeFilter: ['style'] });
  ['click', 'input', 'change'].forEach(function (ev) { root.addEventListener(ev, function () { setTimeout(schedule, 0); }, true); });
  var watch = ['totalPrice', 'friendlySize', 'previewImg', 'weldingToggle', 'grommetsToggle', 'quantityInput', 'bannerThumbTabs'];
  var mo = new MutationObserver(schedule);
  watch.forEach(function (id) {
    var el = $(id);
    if (el) mo.observe(el, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['src', 'class', 'style', 'value'] });
  });

  function sync() { mq.matches ? enable() : disable(); }
  if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
  buildGrommets();
  sync();
  schedule();
  setTimeout(schedule, 800);
  // Header height settles after fonts/images load; re-measure the canvas then.
  function settle() { if (active) refit(); }
  window.addEventListener('load', settle);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(settle);
  setTimeout(settle, 1200);
})();

/* Header delivery timeline: mirrors the builder's own shipping widget
   (countdown, gauge, ship date, delivery date), so both always show the same values. */
(function () {
  var eta = document.querySelector('#blazing-banner-builder-v43 .bbx-eta');
  if (!eta) return;
  var slots = eta.querySelectorAll('[data-bbx-eta]');
  var tiles = eta.querySelectorAll('[data-bbx-clock] b');
  var fuel = eta.querySelector('[data-bbx-fuel]');
  function copy() {
    slots.forEach(function (slot) {
      var src = document.getElementById(slot.getAttribute('data-bbx-eta'));
      var text = src && src.textContent.trim();
      if (text && slot.textContent !== text) slot.textContent = text;
    });
    var clock = document.getElementById('shipCountdown');
    var parts = clock ? clock.textContent.trim().split(':') : [];
    if (parts.length === 3) {
      parts.forEach(function (v, i) {
        var tile = tiles[i];
        if (!tile || tile.textContent === v) return;
        tile.textContent = v;
        tile.classList.remove('is-tick');
        void tile.offsetWidth;   // restart the tick animation
        tile.classList.add('is-tick');
      });
      // Last two hours before the cutoff: the box heats up
      eta.classList.toggle('is-urgent', +parts[0] < 2);
    }
    var gauge = document.getElementById('shipGaugeFill');
    if (fuel && gauge && gauge.style.width) fuel.style.width = gauge.style.width;
  }
  copy();
  setInterval(copy, 1000);
})();
/* Buying-guide answers open as floating pop-ups (like the artwork-fit "i")
   instead of expanding inline and pushing the panel down. The builder's own
   handler still toggles `hidden`; this only positions, closes and zooms. */
(function () {
  var root = document.getElementById('blazing-banner-builder-v43');
  if (!root) return;

  function setup() {
    var triggers = Array.prototype.slice.call(root.querySelectorAll('.builder-help-trigger'));
    var pops = [];
    triggers.forEach(function (trigger) {
      var pop = document.getElementById(trigger.getAttribute('data-help'));
      if (!pop || pop.classList.contains('bb-help-pop')) return;
      pop.classList.add('bb-help-pop');
      pop.setAttribute('role', 'dialog');
      pop.setAttribute('aria-label', trigger.textContent.trim());
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'bb-help-close';
      close.setAttribute('aria-label', 'Close');
      close.textContent = '×';
      close.addEventListener('click', function (e) {
        e.stopPropagation();
        hide(pop, trigger);
        trigger.focus();
      });
      pop.insertBefore(close, pop.firstChild);
      pop.addEventListener('click', function (e) { e.stopPropagation(); });
      root.appendChild(pop);   // out of the panel's flow, so opening it moves nothing
      pops.push({ pop: pop, trigger: trigger });
      trigger.addEventListener('click', function () {
        requestAnimationFrame(function () { if (!pop.hidden) place(pop, trigger); });
      });
    });
    if (getComputedStyle(root).position === 'static') root.style.position = 'relative';

    function hide(pop, trigger) {
      pop.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }
    function place(pop, trigger) {
      var r = trigger.getBoundingClientRect(), box = root.getBoundingClientRect();
      var w = pop.offsetWidth, h = pop.offsetHeight;
      var left = Math.max(12, Math.min(r.left - box.left + r.width / 2 - w / 2, box.width - w - 12));
      var below = r.bottom + h + 16 < window.innerHeight || r.top < h + 16;
      var top = below ? r.bottom - box.top + 10 : r.top - box.top - h - 10;
      pop.style.left = left + 'px';
      pop.style.top = top + 'px';
      pop.style.setProperty('--bb-arrow', (r.left - box.left + r.width / 2 - left) + 'px');
      pop.classList.toggle('is-above', !below);
    }
    document.addEventListener('click', function () {
      pops.forEach(function (p) { if (!p.pop.hidden) hide(p.pop, p.trigger); });
    });
    window.addEventListener('resize', function () {
      pops.forEach(function (p) { if (!p.pop.hidden) place(p.pop, p.trigger); });
    });

    // Hover-to-zoom photos: the zoom follows the pointer
    root.querySelectorAll('.bb-zoom').forEach(function (z) {
      z.addEventListener('mousemove', function (e) {
        var b = z.getBoundingClientRect();
        z.style.setProperty('--zx', ((e.clientX - b.left) / b.width * 100) + '%');
        z.style.setProperty('--zy', ((e.clientY - b.top) / b.height * 100) + '%');
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
/* Carry the size chosen on the home page quote card into the builder.
   ?size=2x3 (height x width, in feet) or ?custom=1&width=6&height=3&unit=ft|in */
(function () {
  var params = new URLSearchParams(window.location.search);
  var w = 0, h = 0;
  var size = params.get('size');
  if (size && /^\d+(\.\d+)?x\d+(\.\d+)?$/i.test(size)) {
    var parts = size.toLowerCase().split('x').map(parseFloat);
    w = Math.max(parts[0], parts[1]) * 12;       // banners on the card are landscape: the larger side is the width
    h = Math.min(parts[0], parts[1]) * 12;
  } else if (params.get('custom') === '1') {
    var k = params.get('unit') === 'in' ? 1 : 12;
    w = parseFloat(params.get('width')) * k;
    h = parseFloat(params.get('height')) * k;
  }
  if (!(w > 0 && h > 0)) return;

  function apply() {
    var preset = document.querySelector('#blazing-banner-builder-v43 .preset-btn[data-w="' + Math.round(w) + '"][data-h="' + Math.round(h) + '"]');
    if (preset) { preset.click(); return; }
    // Not a preset: type it into the custom fields, in inches
    var inBtn = document.querySelector('#blazing-banner-builder-v43 .unit-btn[data-unit="in"]');
    if (inBtn && !inBtn.classList.contains('on')) inBtn.click();
    [['widthInput', w], ['heightInput', h]].forEach(function (pair) {
      var input = document.getElementById(pair[0]);
      if (!input) return;
      input.value = Math.round(pair[1]);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  // after the builder's own start-up code has run
  if (document.readyState === 'complete') setTimeout(apply, 0);
  else window.addEventListener('load', function () { setTimeout(apply, 0); });
})();